/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit OnboardingMailMask/view.blocks to change it.
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function OnboardingMailMask({
  children,
  viewPath = "/DesignSystem/Svgs/OnboardingMailMask",
  alignSelf = "auto",
  marginTop = 0,
  marginBottom = 0,
  marginLeft = 0,
  marginRight = 0,
  opacity = 1,
  width = 800,
  height = 1194,
  isAnimated,
  animation = "dash 5s linear forwards",
  strokeDashoffset = 1000,
  strokeDasharray = 1000,
  fill = "#FFF"
  
}) {
  return (<React.Fragment
>
<svg
  data-testid="OnboardingMailMask.Svg"
  data-view-path={viewPath}
 viewBox="0 0 800 1194"
 overflow="visible"
 style={{'--as-1-GgiDn': alignSelf,'--mt-2-GgiDn': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--mb-3-GgiDn': typeof marginBottom === 'number' ? `${marginBottom}px` : marginBottom,'--ml-4-GgiDn': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--mr-5-GgiDn': typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--o-6-GgiDn': opacity,'--w-10-GgiDn': typeof width === 'number' ? `${width}px` : width,'--h-11-GgiDn': typeof height === 'number' ? `${height}px` : height,'--a-7-GgiDn': isAnimated ? animation : "none",'--sd-8-GgiDn': isAnimated ? strokeDashoffset : 0,'--sd-9-GgiDn': isAnimated ? strokeDasharray : 0}}
 className={`views-block ${styles.Svg}`}
>
<path
  data-testid="OnboardingMailMask.SvgPath"
  data-view-path={viewPath}
 d="M740 0c0 187.8-152.2 340-340 340S60 187.8 60 0H0v1194h800V0h-60z"
 style={{'--f-12-GgiDn': fill}}
 className={`views-block ${styles.SvgPath}`}
/>
</svg>
{children}
</React.Fragment>)
}